export default __webpack_public_path__ + "static/media/access-health-information_556x323.868c9587.jpg";